const ALIASES = {
	general: ['general', 'general booking'],
	hugoPlus: ['hugo+'],
	quote: ['quote'],
	personal: ['personal', 'personal booking'],
	lawyer: ['lawyer'],
	admin: ['admin'],
};

export function getProjectTypeInfoKey(projectType) {
	const normalized = String(projectType || '').trim().toLowerCase();
	if (!normalized) return null;

	for (const [key, values] of Object.entries(ALIASES)) {
		if (values.includes(normalized)) {
			return key;
		}
	}
	return null;
}
